import React from 'react';
import { InboxOutlined } from '@ant-design/icons';
import { message, Upload } from 'antd';
const { Dragger } = Upload;

const UploadComponent = ({ setFiles }) => (
    <Dragger
        name='file'
        multiple
        beforeUpload={(file) => {
            // Return false to prevent automatic upload
            return false;
        }}
        onChange={(info) => {
            const { status } = info.file;
            if (status === 'done') {
                message.success(`${info.file.name} file uploaded successfully.`);
                setFiles(info.fileList)
            }
            setFiles(info.fileList)
        }}
        onDrop={(e) => { }}>
        <p className="ant-upload-drag-icon">
            <InboxOutlined />
        </p>
        <p className="ant-upload-text">Click or drag file to this area to upload</p>
        <p className="ant-upload-hint">
            Support for a single or bulk upload. Strictly prohibited from uploading company data or other
            banned files.
        </p>
    </Dragger>
);
export default UploadComponent;